import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const REAL_PHOTOS = [{
  src: 'https://cdn.magicpatterns.com/uploads/33vHLTnabL2uWLAhXboGLX/WhatsApp_Image_2026-05-11_at_12.47.39_PM.jpg',
  alt: 'Lettore con la collezione Piacere, Colpa e Vuoto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2duFZvKRHuDgQCEyYS5XDK/ChatGPT_Image_21_may_2026,_17_32_32.png',
  alt: 'Lettrice che mostra il libro sul tablet'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/n5SmhhXUy7yTLa4qJ7ssum/ChatGPT_Image_21_may_2026,_17_21_20.png',
  alt: 'Lettrice con il libro stampato'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/srchCqeYXqiXcrdQHvuR21/ChatGPT_Image_21_may_2026,_17_00_38.png',
  alt: 'Lettore al parco con il libro'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6UAhpKA3BGsiDx5nNqfcnM/ChatGPT_Image_21_may_2026,_16_26_25.png',
  alt: 'Lettrice che abbraccia il libro a letto'
}];
export function PainSection() {
  const painPoints = [{
    icon: '🔄',
    text: 'Sei ricaduto/a in ciò che avevi promesso di non fare — e la parte peggiore non è stato il gesto, ma la colpa arrivata dopo.'
  }, {
    icon: '😶',
    text: 'Sei una persona funzionale, "hai tutto sotto controllo" — ma c\'è qualcosa che tira in un\'altra direzione e che non riesci a spiegare a nessuno.'
  }, {
    icon: '💪',
    text: 'Hai provato la forza di volontà, le app, i libri, le promesse a te stesso/a. Ha funzionato per un po\'. Poi il ciclo è tornato.'
  }, {
    icon: '🪤',
    text: 'Senti che più tempo passa, più diventa difficile credere che qualcosa possa cambiare.'
  }, {
    icon: '😔',
    text: 'La colpa che senti dopo non ti protegge dalla prossima ricaduta. Ti prepara ad essa.'
  }];
  const [photoIdx, setPhotoIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setPhotoIdx(i => (i + 1) % REAL_PHOTOS.length);
    }, 3500);
    return () => clearInterval(id);
  }, []);
  return <section className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_top_right,rgba(194,0,111,0.15)_0%,transparent_60%),var(--dark-bg)]" data-id="element-148" data-mp="p1pq58pcu26g">
      <div className="max-w-[900px] mx-auto" data-id="element-149" data-mp="yt3ohd5kkvy0">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-150" data-mp="yueyvvtit1y3">
          Ti riconosci?
        </span>
        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-151" data-mp="65zmlh1rwxqg">
          Quante volte hai detto
          <br data-id="element-152" data-mp="b6580fhg9o03" />
          <span className="text-gradient-magenta" data-id="element-153" data-mp="b5vqzhedur6j">"mai più"</span> —<br data-id="element-154" data-mp="f4uvj0w7clxg" />e sei
          ricaduto/a allo stesso modo?
        </h2>
        <ul className="list-none mt-3 mb-3 space-y-2" data-id="element-155" data-mp="k58uzujqmnjv">
          {painPoints.map((point, idx) => <li key={idx} className="flex items-start gap-3 py-3 px-4 bg-[rgba(194,0,111,0.08)] border border-[rgba(194,0,111,0.2)] border-l-4 border-l-magenta rounded-[10px] text-[0.95rem] leading-[1.5] text-white/85 transition-[background-color,border-color,transform] duration-200 ease-out hover:bg-[rgba(194,0,111,0.15)] hover:border-l-magenta-bright hover:translate-x-[5px]" data-id="element-156" data-mp="1qlkt5vmk85fg" data-mpi={idx}>
              <span className="text-[1.4rem] shrink-0 mt-[2px]" data-id="element-157" data-mp="1vwovpb0t925t">
                {point.icon}
              </span>
              <span data-id="element-158" data-mp="1rw61jabg3k0g">{point.text}</span>
            </li>)}
        </ul>
        <div className="bg-gradient-to-br from-[rgba(107,0,182,0.3)] to-[rgba(194,0,111,0.2)] border border-[rgba(194,0,111,0.4)] rounded-2xl py-4 px-5 mt-3 text-center" data-id="element-159" data-mp="1my4k0tto3sr3">
          <blockquote className="font-heading font-bold text-[clamp(1rem,2.5vw,1.35rem)] leading-[1.45] text-white" data-id="element-160" data-mp="1cym36m920n39">
            "Il ciclo non persiste perché sei debole.
            <br data-id="element-161" data-mp="18zws50bhnhms" />
            Persiste perché{' '}
            <em className="text-magenta-bright not-italic" data-id="element-162" data-mp="37c5322qk4hrq">
              nessuno ti ha dato gli strumenti per interromperlo.
            </em>
            "
          </blockquote>
        </div>
        {/* Real People Carousel — Social proof */}
        <div className="mt-6" data-id="element-163" data-mp="3acylyktkbwbr">
          <h3 className="font-heading font-bold text-[0.9rem] tracking-[2px] uppercase text-white/50 mb-3 text-center" data-id="element-164" data-mp="3fee527c6jsri">
            Persone reali con il libro
          </h3>
          <div className="relative max-w-[320px] mx-auto" data-id="element-165" data-mp="35fon6ekaa8b9">
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden border border-magenta/30 shadow-[0_15px_50px_rgba(194,0,111,0.35),0_0_30px_rgba(107,0,182,0.25)] bg-card-bg" data-id="element-166" data-mp="35e3qaiahyda8">
              <AnimatePresence mode="wait" data-id="element-167" data-mp="2wfs5iwwba9pp">
                <motion.img key={photoIdx} src={REAL_PHOTOS[photoIdx].src} alt={REAL_PHOTOS[photoIdx].alt} initial={{
                opacity: 0,
                scale: 1.03
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 0.98
              }} transition={{
                duration: 0.3,
                ease: [0.23, 1, 0.32, 1]
              }} className="absolute inset-0 w-full h-full object-cover" data-id="element-168" data-mp="2wgtdgsi16g37" />
              </AnimatePresence>
              {/* Subtle gradient overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" data-id="element-169" data-mp="1p5gqqpjgz3gm" />
              {/* Verified badge */}
              <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-black/60 backdrop-blur-sm border border-white/10 rounded-full py-1 px-2.5" data-id="element-170" data-mp="1z0qsdc5yh8tv">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400" data-id="element-171" data-mp="282rp87xa1sv0" />
                <span className="text-[0.65rem] text-white/85 font-heading font-bold tracking-wide uppercase" data-id="element-172" data-mp="280du5z2lkgng">
                  Foto reale
                </span>
              </div>
            </div>
            {/* Progress dots */}
            <div className="flex items-center justify-center gap-2 mt-4" data-id="element-173" data-mp="2vrjbkio6rgzv">
              {REAL_PHOTOS.map((_, idx) => <button key={idx} type="button" onClick={() => setPhotoIdx(idx)} aria-label={`Vedi foto ${idx + 1}`} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${idx === photoIdx ? 'w-6 bg-magenta-bright' : 'w-1.5 bg-white/25 hover:bg-white/45'}`} data-id="element-174" data-mp="2qu0zijevglnn" data-mpi={idx} />)}
            </div>
          </div>
        </div>
        {/* Customer Reviews */}
        <div className="mt-6" data-id="element-175" data-mp="27500snsbgrhi">
          <h3 className="font-heading font-bold text-[0.9rem] tracking-[2px] uppercase text-white/50 mb-3 text-center" data-id="element-176" data-mp="275tbu0yb635g">
            Cosa dice chi lo ha già letto
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-177" data-mp="2h5k6q3qs6k62">
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left flex flex-col" data-id="element-178" data-mp="2l6cfywznkp2c">
              <div className="flex items-center gap-2 mb-2" data-id="element-179" data-mp="mqpvo2di6fgg">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-180" data-mp="msaq7rzthyeb">
                  ★★★★★
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-181" data-mp="j8tx6xmy5a56">
                "L'ho letto in una notte. Per la prima volta ho capito perché mi
                stava succedendo tutto questo. Ho pianto, ma di sollievo."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60 mt-auto" data-id="element-182" data-mp="9gecvto6g9h4">
                — Giulia R.
              </p>
            </div>
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left flex flex-col" data-id="element-183" data-mp="127el6gtjjzel">
              <div className="flex items-center gap-2 mb-2" data-id="element-184" data-mp="x94n9ygfmkpa">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-185" data-mp="t6gd9nfzf7qq">
                  ★★★★<span className="text-white/20" data-id="element-186" data-mp="t8kqwx3onl47">★</span>
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-187" data-mp="o9hkb88216u4">
                "Pensavo fosse un altro libro di auto-aiuto generico. Mi sono
                sbagliato. È diretto, senza giri di parole, e funziona."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60 mt-auto" data-id="element-188" data-mp="1cty3fmju7bbz">
                — Marco L.
              </p>
            </div>
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left flex flex-col" data-id="element-189" data-mp="1gtyin9erfqk3">
              <div className="flex items-center gap-2 mb-2" data-id="element-190" data-mp="12yeexl7lrex9">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-191" data-mp="17w62y454mgw6">
                  ★★★★★
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-192" data-mp="1vn1ztfofw2aa">
                "Applico il metodo da 3 settimane e la differenza è reale.
                Avrei voluto trovarlo prima."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60 mt-auto" data-id="element-193" data-mp="1qu8x0xcj740u">
                — Davide M.
              </p>
            </div>
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left flex flex-col" data-id="element-194" data-mp="2ei8nrx9ueuff">
              <div className="flex items-center gap-2 mb-2" data-id="element-195" data-mp="2jc4h2mf5vt49">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-196" data-mp="7v1c8tldk77e">
                  ★★★★<span className="text-white/20" data-id="element-197" data-mp="2whl8erxc586">★</span>
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-198" data-mp="gnv1njujcmyz">
                "Mi ha dato strumenti concreti, non frasi vuote. Lo consiglio a
                chiunque senta di non farcela da solo/a."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60 mt-auto" data-id="element-199" data-mp="3l34cu7u53oit">
                — Valentina S.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}